import { render, staticRenderFns } from "./BannerUpload.vue?vue&type=template&id=8a309d04&scoped=true"
import script from "./BannerUpload.vue?vue&type=script&lang=js"
export * from "./BannerUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a309d04",
  null
  
)

export default component.exports